import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import { ReactComponent as Channels } from '@styles/icons/channels.svg';
import React from 'react';

export const ChannelIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} component={Channels} viewBox={'0 0 21 22'} />
);

export default ChannelIcon;
